import { create } from "zustand";

type UiState = {
  sidebarOpen: boolean;
  collapsed: boolean;
  theme: "light" | "dark";
  toggleSidebar: () => void;
  closeSidebar: () => void;
  toggleCollapsed: () => void;
  toggleTheme: () => void;
};

export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: false,
  collapsed: false,
  theme: (localStorage.getItem("paypilot_theme") as "light" | "dark") ?? "light",
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  closeSidebar: () => set({ sidebarOpen: false }),
  toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
  toggleTheme: () => set((state) => { const theme = state.theme === "light" ? "dark" : "light"; localStorage.setItem("paypilot_theme", theme); return { theme }; }),
}));
